module.exports = __webpack_public_path__ + "media/thankYouSire.cfe3792c.mp3";